<template>
  <ActionsMenu>
    <PostEdit :post="post" v-if="userIsAuthor()" />
    <PostDelete :post="post" v-if="userIsAuthor()" />
    <PostShare :post="post" v-if="communityIsPublic()" />
    <PostReport :post="post" />
  </ActionsMenu>
</template>

<script>

import PostDelete from './PostDelete'
import PostReport from './PostReport'
import PostEdit from './PostEdit'
import ActionsMenu from '../shared/ActionsMenu'
import PostShare from './PostShare.vue'
import { CommunityType } from '../../utils/community-type'

export default {
  name: 'PostMenu',
  components: { ActionsMenu, PostEdit, PostDelete, PostReport, PostShare },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    userIsAuthor() {
      return this.post.author.id === this.$store.getters.currentUserId
    },
    communityIsPublic() {
      return this.post.community.type === CommunityType.PUBLIC
    }
  }
}
</script>
